<template>
	<section class="hero" role="main">
		<div>
			<p>Uma nova experiência!</p>
			<h1>King <span>burger</span></h1>
			<p>Para quem tem um <span>Apetite de um REI!</span></p>
			<a
				class="btn-cta"
				href="https://www.ifood.com.br/delivery/resende-rj/empire-burger-paraiso/5311b12c-54dc-46dc-9349-9537daf4ca74"
				target="_blank"
				rel="noopener"
				>Comprar Agora</a
			>
		</div>
	</section>
</template>

<script>
export default {
	name: 'HeroSection'
};
</script>

<style></style>
